export function debounce<F extends (...args: any) => any>(fn: F, ms = 300) {
  let timeoutId: ReturnType<typeof setTimeout>;
  return function deb(this: any, ...args: Parameters<F>) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), ms);
  };
}
